import { createApp } from 'vue'
import App from './App.vue'
const app = createApp(App);

import Router from './router'
import VueMatomo from 'vue-matomo'

import { library } from '@fortawesome/fontawesome-svg-core';
import { faSearch, faQuestionCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

library.add(faSearch, faQuestionCircle);
app.component('FontAwesomeIcon', FontAwesomeIcon);

import 'bootstrap/dist/js/bootstrap.bundle'
import 'bootstrap/dist/css/bootstrap.min.css';
import '@/cndBootstrap.min.css'
import '@/_custom.scss'
import '@mdi/font/css/materialdesignicons.css' // Ensure you are using css-loader

import Spinner from '@/components/Spinner.vue'

// import VueScrollTo from 'vue-scrollto';
// app.use(VueScrollTo);
// app.use(VueHtml2pdf);

// Vuetify
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import { aliases, mdi } from 'vuetify/iconsets/mdi';

const ngaTheme = {
  colors: {
    background: '#FFFFFF',
    surface: '#FFFFFF',
    'surface-bright': '#FFFFFF',
    'surface-light': '#EEEEEE',
    'surface-variant': '#424242',
    'on-surface-variant': '#EEEEEE',
    primary: '#337ab7',
    'primary-darken-1': '#1F5592',
    secondary: '#48A9A6',
    'secondary-darken-1': '#018786',
    error: '#B00020',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FB8C00',
  },
};

// Components
const vuetify = createVuetify({
  components,
  directives,
  theme: {
    defaultTheme: 'ngaTheme',
    themes: {
      ngaTheme,
    },
    icons: {
      defaultSet: 'mdi',
      aliases,
      sets: {
        mdi,
      },
    },
  },
});

app.use(vuetify);

app.component('SpinnerLoaderIcon', Spinner);

// setup as shown here https://router.vuejs.org/guide/advanced/meta.html#route-meta-fields
// router.beforeEach((to, from, next) => {
//   const token = window.localStorage.getItem('tokens-gx');
//   if (to.matched.some(record => record.meta.requiresAuth)) {
//     // this route requires auth, check if logged in
//     //also, turn on 'GeoAxis' if needed. See 'config.json' in src
//     if (token == null || Config.geoAxis == false) {
//       next('/');
//     } else if (token != null && Config.geoAxis) {
//       next();
//     }
//   } else {
//     next(); // make sure to always call next() to close the pipeline!
//   }
// });


//Only run Matomo analytics if app is in production mode and specific domain
if (
  process.env.NODE_ENV == 'production' &&
  window.location.hostname == 'fgs-dps.gs.mil'
) {
  app.use(VueMatomo, {
    // Configure your matomo server and site
    host: '//webanalytics.nga.mil',
    siteId: 414,

    // Overrides the autogenerated tracker endpoint entirely
    // Default: undefined
    // trackerUrl: 'https://example.com/whatever/endpoint/you/have',

    // Enables automatically registering pageviews on the router
    router: Router,

    // Enables link tracking on regular links. Note that this won't
    // work for routing links (ie. internal Vue router links)
    // Default: true
    enableLinkTracking: true,

    // Require consent before sending tracking information to matomo
    // Default: false
    requireConsent: false,

    // Whether to track the initial page view
    // Default: true
    trackInitialView: true,

    // Changes the default .js and .php endpoint's filename
    // Default: 'piwik'
    trackerFileName: 'piwik',

    // Whether or not to log debug information
    // Default: false
    debug: false
  });
}

import vScrollTo from './directives/v-scroll-to.js';
app.directive('scroll-to', vScrollTo);

app.use(Router).mount('#app');